var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('event-tabs',{attrs:{"event-data":_vm.eventData,"event-template-type-id":_vm.EVENT_TEMPLATE_TYPE_CONFIGURATION_TEMPLATE,"loading":_vm.loading,"omitted-fields":_vm.omittedFields,"is-template":true},on:{"saved":_vm.getData}})}
var staticRenderFns = []

export { render, staticRenderFns }